import styled from "styled-components";
import { Box, Typography } from "@mui/material";
import Button from "../../components/button";
import { THEME } from "../../styles/theme";

export const ProfileContainer = styled.div`
  margin: var(--page-spacing);
  padding-bottom: var(--page-spacing);
`;

export const TitleBox = styled(Box)`
  margin-bottom: 1.5rem;
  @media (max-width: 900px) {
    margin-bottom: 1rem;
  }
`;

export const MainContainer = styled(Box)`
  background-color: ${THEME.palette.background.paper};
  box-shadow: ${THEME.shadows[1]};
  border-radius: 12px;
  padding: var(--page-spacing);
  display: flex;
  flex-direction: column;
`;

export const SectionsContainer = styled(Box)`
  display: flex;
  gap: 32px;
  margin-top: 24px;

  @media (max-width: 900px) {
    margin-top: 0px;
    flex-direction: column;
    gap: 0;
  }
`;

export const SectionContainer = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;

  @media (max-width: 900px) {
    &:last-child {
      margin-top: 2rem;
    }
  }
`;

export const SectionDescription = styled(Typography)`
  color: ${THEME.palette.text.secondary};
  margin-bottom: 16px;
`;

export const FormContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 500px;
  width: 100%;
`;

export const PasswordFieldsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SaveButton = styled(Button)`
  margin-top: 24px;
  align-self: flex-end;
  min-width: 10rem;

  @media (max-width: 600px) {
    align-self: stretch;
    min-width: auto;
  }
`;

export const MessageContainer = styled(Box)`
  margin-top: 16px;
  text-align: center;
`;
